import React, { useContext, useEffect } from 'react';

import { useAudioContextStore } from '../../stores/AudioContextStore';
import { useMixerStore } from '../../stores/MixerStore';
import {
    readProjectFromFile,
    RydProject
} from '../../model/project';
import { RydInit } from '../../init/RydInit';


export function RydLoadProjectDialog({
    setProject
}: {
    setProject: (project: RydProject) => void
}) {

    const audioContextStore = useAudioContextStore();
    const mixerStore = useMixerStore();

    useEffect(() => {
        console.log('INIT: AUDIO CONTEXT 1 (from LoadProjectDialog)');
        RydInit.initAudioContext(audioContextStore);
    }, [audioContextStore]);

    const loadFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.item(0);
        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onload = function (e) {
            const contents = e.target?.result;
            if (!contents) {
                return;
            }
            console.log('File loaded:', file.name, 'Contents:', contents);
            if (!audioContextStore.audioContext) {
                throw new Error('AudioContext is not initialized. Please initialize it before loading a project.');
            }
            const p = readProjectFromFile(contents, audioContextStore.audioContext);
            p.mixerState.tracks.forEach(t => {
                mixerStore.mixer?.addTrack(t);
            });
            mixerStore.forceUpdate();
            console.log('Loaded project:', p);
            setProject(p);
        };

        reader.readAsText(file);
    };

    if (!audioContextStore.audioContext) {
        return (<span>Initializing...</span>);
    }

    return (<>
        <button onClick={() => {
            const p = RydProject.createForNewProject('new project', true);
            console.log('Loading new project onto workspace');
            setProject(p)
        }}>New</button>
        <br />
        Open: <input type="file" onChange={loadFile} />

    </>);
}
